import React from "react";
import { CARD_EDITOR_TOOLTIPS, type CardEditorTooltipKey } from "./cardEditorOptions";

interface InfoDotProps {
  /** Field path key into CARD_EDITOR_TOOLTIPS. */
  fieldKey: CardEditorTooltipKey;
  /** Optional inline override when the dictionary entry isn't enough. */
  text?: string;
  size?: "sm" | "md";
}

/**
 * Phase 2 cards-launch — single source of truth for `(i)` tooltip
 * dots in the admin Cards UI. Hover/focus reveals the matching copy
 * from `CARD_EDITOR_TOOLTIPS`. Test
 * (`cardEditorOptions.tooltips.test.ts`) asserts every required key
 * has non-empty copy.
 */
export default function InfoDot({ fieldKey, text, size = "sm" }: InfoDotProps) {
  const tooltip = (text || CARD_EDITOR_TOOLTIPS[fieldKey] || "").trim();
  return (
    <span
      role="img"
      aria-label={tooltip ? `Help: ${tooltip}` : `Help`}
      title={tooltip}
      tabIndex={0}
      style={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        width: size === "md" ? 18 : 14,
        height: size === "md" ? 18 : 14,
        marginLeft: 4,
        borderRadius: "50%",
        background: "rgba(99, 102, 241, 0.18)",
        color: "#3730a3",
        fontSize: size === "md" ? 12 : 10,
        fontWeight: 700,
        cursor: "help",
        userSelect: "none",
      }}
    >
      i
    </span>
  );
}
